<template>
  <v-row>
    <v-col cols="12" class="text-right">
      <px-dashboard-filtro />
      <px-select-date-range :initial-date-selection="dateSelection"
                            @change="onChangeDate"/>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { SET_DATE_ACT } from '@/store/dashboard/actions.type';
import DashboardFiltro from '@/modules/dashboard/DashboardFiltro.vue';

export default {
  computed: {
    ...mapGetters('dashboard', ['dateSelection']),
  },
  methods: {
    ...mapActions('dashboard', {
      setDateSelection: SET_DATE_ACT,
    }),
    onChangeDate(dateState) {
      this.setDateSelection(dateState);
      this.$emit('change', dateState);
    },
  },
  components: {
    pxDashboardFiltro: DashboardFiltro,
  },
};
</script>
